<template>
  <v-app id="app" light>
    <v-navigation-drawer
      clipped
      fixed
      v-model="drawer"
      app
    >
      <v-list dense>

        <v-list-tile
          :to="{name: 'alert'}"
          v-if="this.shouldDisplay('/alert')">
          <v-list-tile-action>
            <v-icon color=red>local_hospital</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Alert</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          :to="{name: 'dashboard'}"
          v-if="this.shouldDisplay('/dashboard')">
          <v-list-tile-action>
            <v-icon>dashboard</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group v-if="this.shouldDisplay('devices')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>watch</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Devices</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'deviceList'}"
            v-if="this.shouldDisplay('/device')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Active Devices</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'deviceNew'}"
            v-if="this.shouldDisplay('/deviceNew')">
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add New Device</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
            <v-list-tile
            :to="{name: 'deviceListInactive'}"
            v-if="this.shouldDisplay('view_inactive_devices')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Inactive Devices</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="this.shouldDisplay('login_users')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>fa-id-badge</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Login Users</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'loginUser'}"
            v-if="this.shouldDisplay('/loginUser')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'loginUserNew'}"
            v-if="this.shouldDisplay('/loginUserNew')">
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add New User</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="this.shouldDisplay('customer_accounts')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>domain</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Customer Accounts</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'customerAccountList'}"
            v-if="this.shouldDisplay('/customerAccount')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Active Accounts</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'customerAccountNew'}"
            v-if="this.shouldDisplay('/customerAccountNew')">
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add New Account</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
            <v-list-tile
            :to="{name: 'customerAccountListInactive'}"
            v-if="this.shouldDisplay('/customerAccount')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Inactive Accounts</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="this.shouldDisplay('care_groups')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>view_module</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Care Groups</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'careGroupList'}"
            v-if="this.shouldDisplay('/careGroup')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Active Groups</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'careGroupNew'}"
            v-if="this.shouldDisplay('/careGroupNew')">
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add New Care Group</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'careGroupListInactive'}"
            v-if="this.shouldDisplay('/careGroup')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Inactive Groups</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="this.shouldDisplay('care_users')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>group</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Care Users</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'careUserList'}"
            v-if="this.shouldDisplay('/careUser')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Active Users</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'careUserNew'}"
            v-if="this.shouldDisplay('/careUserNew')">
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add New Care User</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'careUserListInactive'}"
            v-if="this.shouldDisplay('view_inactive_care_users')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Inactive Users</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="this.shouldDisplay('system_admin')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>settings_applications</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>System Admin</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'rolePermission'}">
            <!-- v-if="this.shouldDisplay('/rolePermission')" -->
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Roles</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'permissionRole'}">
            <!-- v-if="this.shouldDisplay('/rolePermission')" -->
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>List Permissions</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{name: 'roleAdd'}"
            v-if="this.shouldDisplay('/roleAdd')">
            <v-list-tile-action>
              <v-icon>add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add New Role</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="this.shouldDisplay('developers')" no-action>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>code</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>For Developer's Testing</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
          :to="{name: 'testLayout'}">
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Test layout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
          :to="{name: 'testLayout2'}">
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Test layout 2</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
          :to="{name: 'jwt'}">
            <v-list-tile-action>
              <v-icon>info</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Show JWT and VUEX content</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
          :to="{name: 'test403'}">
            <v-list-tile-action>
              <v-icon>info</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Error Testing</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
        :to="{name: 'aboutGreyguard'}">
          <v-list-tile-action>
            <v-icon>info_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>About Greyguard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
        :to="{name: 'contactUs'}">
          <v-list-tile-action>
            <v-icon>info_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contact Us</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>

    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link to="/home" tag="span" style="cursor: pointer">Vital Sign Portal</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          v-if="!$store.state.isUserLoggedIn"
          flat
          :to="{name: 'register'}">
          <v-icon left>fa-user</v-icon>
          Sign Up
        </v-btn>
        <v-btn
          v-if="!$store.state.isUserLoggedIn"
          flat
          :to="{name: 'login'}">
          <v-icon left>fa-sign-in</v-icon>
          Sign In
        </v-btn>
        <v-btn
          v-if="this.shouldDisplay('/loginUserProfile')"
          flat
          :to="{name: 'loginUserProfile'}">
          <v-icon left>fa-user</v-icon>
          My Profile
        </v-btn>
        <v-btn
          v-if="$store.state.isUserLoggedIn"
          flat
          @click.native="logout">
            <v-icon left>fa-sign-out</v-icon>
          Sign Out
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout justify-left align-top column>
          <main>
            <router-view></router-view>
          </main>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app fixed>
      <span>Greyguard Healthcare Solutions Inc &copy; 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
  import mixins from './mixins.js'

  export default {
    name: 'app',
    data: () => ({
      drawer: null
    }),
    props: {
      source: String
    },
    mixins: [mixins],
    methods: {
      logout () {
        this.$store.dispatch('setToken', null)
        this.$store.dispatch('setUser', null)
        this.$router.push({
          name: 'home'
        })
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue